// The File Browser and the video editor are separate blade pages, so a selection can only cross
// by storage plus a page load (the same trick as 'optix-lab-presets').
const STORAGE_KEY = 'video-import-files';
const MAX_AGE_MS = 5 * 60 * 1000;

export function setPendingVideoImport(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ items, createdAt: Date.now() }));

    return true;
  } catch (error) {
    console.error('[setPendingVideoImport]', error);

    return false;
  }
}

// A payload the video page never picked up must not import itself days later.
export function takePendingVideoImport() {
  let raw = null;

  try {
    raw = localStorage.getItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('[takePendingVideoImport]', error);

    return [];
  }

  if (!raw) {
    return [];
  }

  try {
    const { items, createdAt } = JSON.parse(raw);

    if (!Array.isArray(items) || Date.now() - createdAt > MAX_AGE_MS) {
      return [];
    }

    return items;
  } catch (error) {
    console.error('[takePendingVideoImport]', error);

    return [];
  }
}
